import { FunctionalComponent, h } from 'preact';
import { TabPanel as StyledTabPanel, TabPanelContainer } from './Tabs.styles';
import { PanelProps } from './interface';
import { useDeviceState } from '../../hooks';
import { useEffect } from 'preact/hooks';
import { useTabs } from './Tabs';

export const TabPanel: FunctionalComponent<PanelProps> = ({ children, id, testid }) => {
  const { registerPanel, selected, unRegisterPanel } = useTabs();
  const { isMobile } = useDeviceState();

  useEffect(() => {
    registerPanel(id);

    return () => {
      unRegisterPanel(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const active = selected === id;

  return (
    <StyledTabPanel active={active} data-testid={testid} role="tabpanel" tabIndex={-1}>
      <TabPanelContainer withFadingTop={!isMobile}>{children}</TabPanelContainer>
    </StyledTabPanel>
  );
};
